import { useMatches } from "react-router";
import type { RouteHandle } from "../modules/types";
import { usePageTitle } from "../ui/usePageTitle";

/** Kept for shell callers; same as ui `usePageTitle`. */
export const useDocumentTitle = usePageTitle;

/** Applies the deepest route `handle.title` as `<Page> • Clockify`. */
export function useRouteTitle() {
  const matches = useMatches();
  const match = [...matches].reverse().find((m) => (m.handle as RouteHandle | undefined)?.title);
  usePageTitle((match?.handle as RouteHandle | undefined)?.title);
}
